import React from 'react';
import Card from '@src/components/Card';
import ReferralIntro from './ReferralIntro';
import ReferralCode from './ReferralCode';
import { StyledReferralContainer } from './index.style';
import ReferralStats from './ReferralStats';

const ReferralContainer = () => (
  <StyledReferralContainer>
    <Card flexDirection="column" className="referral-card">
      <ReferralIntro />
      <ReferralCode />
      <ReferralStats />
    </Card>
  </StyledReferralContainer>
);

export default ReferralContainer;
